import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Undo, Redo } from "lucide-react";
import { useUndoRedo } from "../hooks/useUndoRedo";
import { Canvas } from "../types/canvasTypes";

interface UndoRedoToolbarProps {
  canvas: Canvas | undefined;
  className?: string;
}

export const UndoRedoToolbar: React.FC<UndoRedoToolbarProps> = ({ canvas, className }) => {
  const { undo, redo, canUndo, canRedo } = useUndoRedo(canvas, {
    enableKeyboardShortcuts: false, // Disable keyboard shortcuts in this component to avoid conflicts
  });

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            onClick={undo}
            disabled={!canUndo}
            className="h-8 w-8 p-0"
          >
            <Undo className="h-4 w-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Undo (Ctrl+Z)</p>
        </TooltipContent>
      </Tooltip>

      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            onClick={redo}
            disabled={!canRedo}
            className="h-8 w-8 p-0"
          >
            <Redo className="h-4 w-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Redo (Ctrl+Y / Ctrl+Shift+Z)</p>
        </TooltipContent>
      </Tooltip>
    </div>
  );
}; 